import axios from 'axios'
import Utils from '../../utils/utils'
import CONST from '../../utils/const'
import config from '../../config'

export async function getDevicrType() {
    let response = {}
    try {
        response = await axios.get(`${config.eastCoastDataApi()}BaseData/Device/deviceTypes`)

    } catch (err) {
        console.error('iisi getDevcie: ', err)
        return null
    }

    return response.data
}

export async function getDevcie(condition = { deviceType: '' }) {
    let response = {}
    let deviceType = Utils.isEmptyObject(condition.deviceType) ? '' : condition.deviceType
    let deviceTypeQuery = Utils.isEmptyString(deviceType) ? '' : `/deviceType/${deviceType}`
    try {
        response = await axios.get(`${config.eastCoastDataApi()}BaseData/Device${deviceTypeQuery}`)

    } catch (err) {
        console.error('iisi getDevcie: ', err)
        return null
    }

    const deviceData = handleLntLng(response)
    return { deviceData: deviceData, deviceType: deviceType }
}

function handleLntLng(response) {
    if (Utils.isEmptyObject(response) || Utils.isEmptyObject(response.data)) {
        return null
    }

    const data = response.data

    for (let i = 0; i < data.length; i++) {
        data[i] = Utils.handleDeviceLntLng(data[i])

        data[i][CONST.TRAFFIC_CCTV_KEY.TYPE] = CONST.MAP_ICON_TYPE.IISI
    }

    return data
}

export async function postDevcie(device = {}) {
    let response = {}
    if (Utils.isEmptyObject(device)) {
        console.error('iisi postDevcie: device is null')
        Utils.setApiResponsSuccess(response)
        return response
    }

    try {
        response = await axios.post(`${config.eastCoastDataApi()}BaseData/Device`, device)

    } catch (err) {
        console.error('iisi postDevcie: ', err)
        return null
    }

    Utils.setApiResponsSuccess(response)
    return response
}

export async function putDevice(device = {}) {
    let response = {}
    if (Utils.isEmptyObject(device) || Utils.isEmptyObject(device.id)) {
        console.error('iisi putDevice: device is null')
        Utils.setApiResponsSuccess(response)
        return response
    }

    try {
        response = await axios.put(`${config.eastCoastDataApi()}BaseData/Device/${device.id}`, device)

    } catch (err) {
        console.error('iisi putDevice: ', err)
        Utils.setApiResponsSuccess(response)
        return response
    }

    Utils.setApiResponsSuccess(response)
    return response
}

export async function deleteDevice(deviceId = '') {
    let response = {}
    if (Utils.isEmptyString(deviceId)) {
        console.error('iisi deleteDevice: deviceId is empty')
        Utils.setApiResponsSuccess(response)
        return response
    }

    try {
        response = await axios.delete(`${config.eastCoastDataApi()}BaseData/Device/${deviceId}`)

    } catch (err) {
        console.error('iisi deleteDevice: ', err)
        return null
    }

    Utils.setApiResponsSuccess(response)
    return response
}